import * as React from 'react'

function useLazyRef<T>(fn: () => T): React.MutableRefObject<T> {
  const initializedRef = React.useRef(false)
  const ref = React.useRef<T>(undefined as T)

  if (!initializedRef.current) {
    ref.current = fn()
    initializedRef.current = true
  }

  return ref
}

export { useLazyRef }
